var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '@dixa/lib-shared-habla';
import { boundMethod } from 'autobind-decorator';
import classnames from 'classnames';
import { PureComponent } from 'react';
import styles from './failedBulkToggle.module.scss';
export class FailedBulkToggle extends PureComponent {
    handleOnClick() {
        const { onClick, notification } = this.props;
        onClick(notification);
    }
    render() {
        const { open, className } = this.props;
        const rootClass = classnames({
            [styles.root]: styles.root,
            [styles.rootOpen]: open,
        }, className);
        return (_jsx("div", Object.assign({ onClick: this.handleOnClick, className: rootClass }, { children: _jsx(Icon, { name: "angle-right" }) })));
    }
}
__decorate([
    boundMethod
], FailedBulkToggle.prototype, "handleOnClick", null);
